import { action } from "satcheljs";

export const handleConnectorAuthRequest = action(
    "HANDLE_CONNECTOR_AUTH_REQUEST",
    () => ({})
);
